export default () => {
  if (process.client) {
    window.addEventListener('load', () => {
      const script = document.createElement('script');
      script.src = '/js/microsoftAds.js';
      script.async = true;
      script.onload = () => {
        console.log('Microsoft Ads script loaded successfully');
      };
      script.onerror = (err) => {
        console.error('Failed to load Microsoft Ads script', err);
      };
      document.head.appendChild(script);
    });
  }
}
